import { Panel, Empty } from "./chartTheme";
import { groupStats } from "../../lib/reports";
import { fmt } from "../../lib/api";
import { useSort, SortTh } from "../../lib/useSort";

const COLS = [["key", "Name"], ["n", "Tests"], ["dl", "Avg ↓"], ["ul", "Avg ↑"], ["ping", "Ping"], ["issueRate", "Issue %"]];
const ACC = Object.fromEntries(COLS.map(([k]) => [k, (r) => r[k]]));

export const WorstTable = ({ title, tests, keyFn, testId, className }) => {
  const rows = groupStats(tests, keyFn).sort((a, b) => b.issueRate - a.issueRate || a.dl - b.dl).slice(0, 8);
  const { sorted, sort, toggle } = useSort(rows, ACC);
  return (
    <Panel title={title} testId={testId} className={className}>
      {!rows.length ? <Empty /> : (
        <table className="w-full text-xs">
          <thead className="text-neutral-500 text-left">
            <tr>{COLS.map(([k, l]) => <SortTh key={k} k={k} label={l} sort={sort} toggle={toggle} className="py-1 pr-2" />)}</tr>
          </thead>
          <tbody>
            {sorted.map((r) => (
              <tr key={r.key} className="border-t border-white/5">
                <td className="py-1.5 text-white truncate max-w-[140px]">{r.key}</td>
                <td>{r.n}</td>
                <td>{fmt(r.dl)}</td>
                <td>{fmt(r.ul)}</td>
                <td>{fmt(r.ping, 0)}</td>
                <td className={r.issueRate >= 30 ? "text-[#FF3B30]" : r.issueRate >= 10 ? "text-[#FF9F0A]" : "text-[#32D74B]"}>{fmt(r.issueRate, 0)}%</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </Panel>
  );
};
